import {CustomNodeData} from '../tabs/ReactFlowTab'
import {
    type Edge,
    type Node,
} from '@xyflow/react';


/**
 * Permite generar los nodos y edges a partir de los datos serializados en texto.
 *
 * @export
 * @param {any[]} nodes_text 
 * @param {any[]} edges_text 
 * @param {React.Dispatch<React.SetStateAction<Node<CustomNodeData>[]>>} setNodes 
 * @param {React.Dispatch<React.SetStateAction<Edge[]>>} setEdges 
 */
export function LoadNodes(nodes_text: any[], edges_text: any[], setNodes: React.Dispatch<React.SetStateAction<Node<CustomNodeData>[]>>, setEdges: React.Dispatch<React.SetStateAction<Edge[]>>) {
    const newNodes = nodes_text || [];
    const newEdges = edges_text || [];
    // Transforma los nodos para asegurar estructura y posición
    const transformedNodes = Array.isArray(newNodes)
        ? newNodes.map((n:any, idx:number) => ({
            ...n,
            id: n.id || (idx + 1).toString(),
            type: n.type || 'custom',
            position: n.position || { x: 100 + idx * 50, y: 100 },
            data: {
                label: n.data?.label || n.label || `Node ${n.id || (idx + 1)}`,
                inputs: n.data?.inputs ?? n.inputs ?? 1,
                outputs: n.data?.outputs ?? n.outputs ?? 1,
                custom_data: n.data?.custom_data || {},
            }
        }))
        : [];
    setNodes(transformedNodes);
    setEdges(Array.isArray(newEdges) ? newEdges : []);
}
